import {
  Checkbox,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
  Button,
} from "@mui/material";
import { red } from "@mui/material/colors";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import * as React from "react";
import Dialog from "@mui/material/Dialog";
import ReCAPTCHA from "react-google-recaptcha";
import * as Yup from "yup";
import ErrorText from "../common/ErrorText";
import { useEffect } from "react";
import { useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import styles from "../../Styles/modal.module.css";
import { useFormik } from "formik";
import apiCall from "../../helpers/apifactory";
import Select from "react-select";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const TcsEcom = () => {
  const modalRef = useRef(null);
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const [showBottom, setShowBottom] = useState(false);
  const [cities, setCities] = useState([]);
  const [area, setArea] = useState([]);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [clickCount, setClickCount] = useState(0);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const formik = useFormik({
    initialValues: {
      bussinessType: "yes",
      bussinessType2: "",
      compAccTitle: "",
      ownerName: "",
      cnic: "",
      ntn: "",
      city: undefined,
      location: "",
      pickAddress: "",
      compNum: "",
      mobNum: "",
      mobNum2: "",
      compEmail: "",
      facebook: false,
      whatsapp: false,
      website: false,
      instagram: false,
      other: false,
      bussinessName: "",
      billAddress: "",
      salesTax: "no",
      monthsInBussiness: "nill",
      avgShip: "nill",
      PhoneNo: "",
      name: "",
      designation: "",
      custMobNum: "",
      custEmail: "",
      custCNIC: "",
      prodRange: {},
      termCond: false,
      undertak: false,
      iban: "",
      bankName: "",
      branch: "",
      bankAcTitle: "",
      // recaptcha: "",
      categories: "",
      // showBottom: false,
    },
    validationSchema: Yup.object({
      compAccTitle: Yup.string().required("This is Required"),
      // area: Yup.object()?.required("This is Required"),
      area: Yup.object(),
      categories: Yup.string().required("This is Required"),
      // bussinessType2: Yup.string().required("This is Required"),
      bussinessType2: Yup.string(),
      ownerName: Yup.string().required("This is Required"),
      cnic: Yup.string()
        .matches(/^[0-9+]{5}-[0-9+]{7}-[0-9]{1}$/, {
          message: "xxxxx-xxxxxxx-x",
          excludeEmptyString: false,
        })
        .required("This is Required"),
      // ntn: Yup.string().when("bussinessType", {
      //   is: (bussinessType) => bussinessType === "yes", //just an e.g. you can return a function
      //   then: Yup.string().required("This is required")
      //   is: (bussinessType) => bussinessType === "no",
      //   then: Yup.string().required("This is required")
      //   // otherwise: Yup.string(),
      // }),
      ntn: Yup.string().when("bussinessType", {
        is: (e) => e === "yes",
        then: Yup.string().required("NTN is required"),
        otherwise: Yup.string(),
      }),
      city: Yup.object()?.required("This is Required"),
      pickAddress: Yup.string().required("This is Required"),
      compNum: Yup.string().required("This is Required"),
      mobNum: Yup.string()
        .matches(/^((\+92)?(0092)?(92)?(0)?)(3)([0-9]{9})$/gm, {
          message: "Invalid phone number",
          excludeEmptyString: false,
        })
        .required("This is Required"),
      mobNum2: Yup.string().matches(
        /^((\+92)?(0092)?(92)?(0)?)(3)([0-9]{9})$/gm,
        {
          message: "Invalid phone number",
          excludeEmptyString: false,
        }
      ),
      compEmail: Yup.string()
        .email("Invalid email address")
        .required("This is Required"),
      facebook: Yup.boolean(),
      whatsapp: Yup.boolean(),
      website: Yup.boolean(),
      instagram: Yup.boolean(),
      other: Yup.boolean(),
      bussinessName: Yup.string().required("This is Required"),
      billAddress: Yup.string().required("This is Required"),
      salesTax: Yup.string(),
      PhoneNo: Yup.string()
        .matches(/^((\+92)?(0092)?(92)?(0)?)(3)([0-9]{9})$/gm, {
          message: "Invalid phone number",
          excludeEmptyString: false,
        })
        .required("This is Required"),
      designation: Yup.string().required("This is Required"),
      prodRange: Yup.object().required("This is Required"),
      iban: Yup.string().required("This is Required"),
      bankName: Yup.string().required("This is Required"),
      branch: Yup.string().required("This is Required"),
      bankAcTitle: Yup.string().required("This is Required"),
      termCond: Yup.boolean()
        .required("Terms and conditions must be accepted.")
        .oneOf([true], "Terms and conditions must be accepted."),
      undertak: Yup.boolean()
        .required("Undertakings must be accepted.")
        .oneOf([true], "Undertakings must be accepted."),
      // recaptcha: Yup.string().required(),
    }),
    // onSubmit: (values, { resetForm }) => {
    onSubmit: (values) => {
      const body = {
        // toEmailID: "muhammad.maaz@tcs.com.pk,yameen.baig@tcs.com.pk",
        toEmailID: "NewAccountOpening@tcs.com.pk",
        // toEmailID: "farhan.ahmed@tcs.com.pk",
        fromEmailID: "noreply@tcs.com.pk",
        emailSubject: values?.compEmail,
        emailText: `
            CompanyName: ${values?.compAccTitle} <br />
            OwnerName: ${values?.ownerName} <br />
            CNICNumber: ${values?.cnic} <br />
            NtnNumber: ${values?.ntn} <br />
            OriginCity: ${values?.city?.value} <br />
            Area: ${values?.area?.value} <br />
            Categories: ${values?.categories} <br />
            BussinessType2: ${values?.bussinessType2} <br />
            PickUpAddress: ${values?.pickAddress} <br />
            companyNumber: ${values?.compNum} <br />
            MobileNumber: ${values?.mobNum} <br />
            MobileNumber2: ${values?.mobNum2} <br />
            CompanyEmail: ${values?.compEmail} <br />
            Facebook: ${values?.facebook} <br />
            Whatsapp: ${values?.whatsapp} <br />
            Website: ${values?.website} <br />
            Instagram: ${values?.instagram} <br />
            Other: ${values?.other} <br />
            BussinessName: ${values?.bussinessName} <br />
            BillingAddress: ${values?.billAddress} <br />
            SalesTax: ${values?.salesTax} <br />
            PhoneNumber: ${values?.PhoneNo} <br />
            Name: ${values?.ownerName} <br />
            Designation: ${values?.designation} <br />
            customerMobileNumber: ${values?.mobNum} <br />
            CustomerEmail: ${values?.compEmail} <br />
            CustomerCNIC: ${values?.cnic} <br />
            Term&Condition: ${values?.termCond} <br />
            UnderTaking: ${values?.undertak} <br />
            IbanNumber: ${values?.iban} <br />
            BankName: ${values?.bankName} <br />
            Branch: ${values?.branch} <br />
            BankAccountTitle: ${values?.bankAcTitle} <br />
            `,
        cc: values?.custEmail,
        bcc: values?.custEmail,
        attachments: [],
        replyTo: values?.custEmail,
      };

      const bodycustomer = {
        toEmailID: values?.compEmail,
        fromEmailID: "noreply@tcs.com.pk",
        emailSubject:
          "Thank You for Choosing TCS! COD Account Opening Request Received.",
        emailText: `Dear ${values?.ownerName}, <br />
        Thank you for reaching out to us. This is an automated response to confirm that we have received your data for COD Account Opening. Your request is important to us, and we appreciate the trust you have placed in our services.
        Our team is diligently reviewing the information you provided. Please allow us 24-48 hours to carefully assess your data and address your inquiry thoroughly.
        Thank you once again for choosing our services. We look forward to working with you.
        Warm regards,
        TCS Ecom Solutions Team.
        `,

        cc: "",
        bcc: "",
        attachments: [],
      };

      apiCall
        .sendEmail(body, {})
        .then((res) => {
          // setShow(true);
          formik.setValues(formik?.initialValues);
          formik.setTouched({}, false);
          apiCall
            .sendEmail(bodycustomer, {})
            .then((res) => {
              formik.setValues(formik?.initialValues);
              formik.setTouched({}, false);
              setShow(true);
              setShowBottom(false);
              formik?.setFieldValue("area", "");

              formik?.setFieldValue("city", "");
              setClickCount(0);
            })
            .catch((error) => {
              console.log("===============", error);
            });
        })
        .catch((error) => {
          console.log("===============", error);
        });

      // resetForm();
    },
  });

  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      top > header_height && window_width > 1024
        ? document.querySelector("a").classList.add("fixed-header-desktop")
        : document.querySelector("a").classList?.remove("fixed-header-desktop");
    },
    false
  );
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      top > header_height && window_width > 1024
        ? document.querySelector("nav").classList.add("fixed-header-desktop")
        : document
            .querySelector("nav")
            .classList?.remove("fixed-header-desktop");
    },
    false
  );

  useEffect(() => {
    let current_page = window.location.href.split("/").at(-1);
    setTimeout(() => {
      document
        .getElementById(`${current_page}`)
        ?.scrollIntoView({ block: "center", behavior: "smooth" });
    }, 100);
  });

  useEffect(() => {
    if (show) {
      modalRef.current.classList?.add(styles.visible);
    } else {
      modalRef.current.classList?.remove(styles.visible);
    }
  }, [show]);

  useEffect(() => {
    apiCall
      .getCity()
      .then((res) => {
        const cityarr = res?.data?.responseData?.cities?.map(
          ({ station_code, station_name }) => ({
            value: station_code,
            label: station_name,
          })
        );
        setCities(cityarr);
      })
      .catch((error) => {
        console.log("===============", error);
      });
  }, []);

  useEffect(() => {
    if (formik?.values?.city?.value)
      apiCall
        .getAreaCode(formik?.values?.city?.value)
        .then((res) => {
          const areaarr = res?.data?.responseData?.data?.map(
            ({ areacode, areaname }) => ({
              value: areaname,
              label: areaname,
            })
          );
          setArea(areaarr);
        })
        .catch((error) => {
          console.log("===============", error);
        });
  }, [formik?.values?.city?.value]);

  const handleInitial = () => {
    if (
      !formik?.errors?.compAccTitle &&
      formik?.values?.compAccTitle &&
      !formik?.errors?.ownerName &&
      formik?.values?.ownerName &&
      !formik?.errors?.cnic &&
      formik?.values?.cnic &&
      (formik?.values?.bussinessType === "yes"
        ? !formik?.errors?.ntn && formik?.values?.ntn
        : true) &&
      !formik?.errors?.city &&
      formik?.values?.city &&
      !formik?.errors?.pickAddress &&
      formik?.values?.pickAddress &&
      !formik?.errors?.compNum &&
      formik?.values?.compNum &&
      !formik?.errors?.mobNum &&
      formik?.values?.mobNum &&
      !formik?.errors?.mobNum2 &&
      formik?.values?.mobNum2 &&
      !formik?.errors?.compEmail &&
      formik?.values?.compEmail
    ) {
      const body = {
        // toEmailID: "muhammad.maaz@tcs.com.pk,yameen.baig@tcs.com.pk",
        toEmailID: "NewAccountOpening@tcs.com.pk",
        // toEmailID: "farhan.ahmed@tcs.com.pk",

        fromEmailID: "noreply@tcs.com.pk",
        emailSubject: formik?.values?.compEmail,
        emailText: `
            CompanyName: ${formik?.values?.compAccTitle} <br />
            OwnerName: ${formik?.values?.ownerName} <br />
            CNICNumber: ${formik?.values?.cnic} <br />
            NtnNumber: ${formik?.values?.ntn} <br />
            City: ${formik?.values?.city?.value} <br />
            Area: ${formik?.values?.area?.value} <br />
            PickAddress: ${formik?.values?.pickAddress} <br />
            CompanyNumber: ${formik?.values?.compNum} <br />
            MobileNumber: ${formik?.values?.mobNum} <br />
            MobileNumber2: ${formik?.values?.mobNum2} <br />
            CompanyEmail: ${formik?.values?.compEmail} <br />
            `,
        attachments: [],
        replyTo: formik?.values?.compEmail,
      };
      apiCall
        .sendEmail(body, {})
        .then((res) => {
          setShowBottom(!showBottom);
          formik.setTouched({}, false);
          setClickCount(0);
        })
        .catch((error) => {
          console.log("===============", error);
        });
    }
    // setClickCount((prevCount) => prevCount + 1);

    if (clickCount >= 2) {
      // Disable the button after the second click
      setIsButtonDisabled(true);
    }

    if (clickCount === 3) {
      // Permanently disable the button after the third click
      setIsButtonDisabled(true);
      alert("Button disabled permanently after the third click.");
    }
  };

  // useEffect(() => {
  //   if (
  //     !formik?.errors?.compAccTitle &&
  //     formik?.values?.compAccTitle &&
  //     !formik?.errors?.ownerName &&
  //     formik?.values?.ownerName &&
  //     !formik?.errors?.cnic &&
  //     formik?.values?.cnic &&
  //     !formik?.errors?.ntn &&
  //     formik?.values?.ntn &&
  //     !formik?.errors?.city &&
  //     formik?.values?.city &&
  //     !formik?.errors?.pickAddress &&
  //     formik?.values?.pickAddress &&
  //     !formik?.errors?.pickAddress &&
  //     formik?.values?.pickAddress &&
  //     !formik?.errors?.compNum &&
  //     formik?.values?.compNum &&
  //     !formik?.errors?.mobNum &&
  //     formik?.values?.mobNum &&
  //     !formik?.errors?.mobNum2 &&
  //     formik?.values?.mobNum2 &&
  //     !formik?.errors?.compEmail &&
  //     formik?.values?.compEmail
  //   )
  //     setShowBottom(true);
  //   else setShowBottom(false);
  // }, [
  //   formik?.values?.city,
  //   formik?.values?.cnic,
  //   formik?.values?.compAccTitle,
  //   formik?.values?.compEmail,
  //   formik?.values?.compNum,
  //   formik?.values?.pickAddress,
  //   formik?.values?.mobNum,
  //   formik?.values?.mobNum2,
  //   formik?.values?.ntn,
  //   formik?.values?.ownerName,
  //   formik?.errors?.compAccTitle,
  //   formik?.errors?.ownerName,
  //   formik?.errors?.cnic,
  //   formik?.errors?.ntn,
  //   formik?.errors?.city,
  //   formik?.errors?.pickAddress,
  //   formik?.errors?.compNum,
  //   formik?.errors?.mobNum,
  //   formik?.errors?.mobNum2,
  //   formik?.errors?.compEmail,
  // ]);

  // const handleCnicChange = (event) => {
  //   const { value } = event.target;
  //   const formattedCnic = value
  //     .replace(/[^\d]/g, "")
  //     .replace(/^(\d{5})(\d{0,7})/, "$1-$2") // Add hyphen after the first 5 digits
  //     .replace(/^(\d{5}-\d{7})(\d{0,1})/, "$1-$2"); // Add hyphen after the next 7 digits

  //   // Check if the length is greater than or equal to the maximum length (15)
  //   if (formattedCnic.length <= 15) {
  //     formik.setFieldValue("cnic", formattedCnic);
  //   }
  // };

  const handleCnicChange = (event) => {
    const { value, selectionStart } = event.target;
    const isBackspace = event.nativeEvent.inputType === "deleteContentBackward";

    const cleanedValue = value.replace(/[^\d]/g, "");

    const cursorPosition =
      selectionStart -
      (isBackspace && cleanedValue[selectionStart] === "-" ? 1 : 0);

    const formattedCnic =
      cleanedValue.slice(0, 5) +
      (cleanedValue.length > 5 ? "-" + cleanedValue.slice(5, 12) : "") +
      (cleanedValue.length > 12 ? "-" + cleanedValue.slice(12, 13) : "");

    formik.setFieldValue("cnic", formattedCnic);

    event.target.setSelectionRange(cursorPosition, cursorPosition);
  };

  const handleProdChange = (e) => {
    if (e?.target?.checked)
      formik?.setFieldValue("prodRange", {
        ...formik?.values?.prodRange,
        [e?.target?.name]: true,
      });
    else
      formik?.setFieldValue("prodRange", {
        ...formik?.values?.prodRange,
        [e?.target?.name]: false,
      });
  };

  useEffect(() => {
    const inputElement = document.getElementById("mobNum");
    const inputElement2 = document.getElementById("mobNum2");
    const inputElement3 = document.getElementById("compNum");

    const handleInputChange = (event) => {
      const inputValue = event.target.value;
      const maxLength = 11;

      if (inputValue.length > maxLength) {
        event.target.value = inputValue.slice(0, maxLength);
      }

      formik.handleChange(event);
    };

    inputElement.addEventListener("input", handleInputChange);
    inputElement2.addEventListener("input", handleInputChange);
    inputElement3.addEventListener("input", handleInputChange);

    return () => {
      inputElement.removeEventListener("input", handleInputChange);
      inputElement2.removeEventListener("input", handleInputChange);
      inputElement3.removeEventListener("input", handleInputChange);
    };
  }, [formik]);

  return (
    <div>
      <div className="bg-[#efefef] flex flex-col justify-center items-center h-[150px]">
        <h1 className="sm:text-[40px] text-[30px] font-bold">
          E-com Solutions
        </h1>
        <p className="text-[1.05rem] mt-[-5px]">Account Opening Form</p>
      </div>

      <div className="my-[3rem]">
        <div className="sm:flex block flex-col justify-center items-center mt-[1rem]">
          <div className="flex flex-col gap-3 p-8  shadow-card text-sm md:w-[45rem] sm:w-[40rem] w-[auto]  mx-[1rem] rounded-md transition-all duration-500">
            <h2 className="font-bold text-[1.1rem]">Business Type</h2>
            <div className="flex gap-4">
              <div className="flex-1 flex flex-col ">
                <div
                  className="MuiFormGroup-root rowflex"
                  role="radiogroup"
                  aria-label="bussinessType"
                >
                  <div className="flex">
                    <FormControl component="fieldset">
                      <FormLabel component="legend">
                        Is your Business a registered tax Payer
                      </FormLabel>
                      <RadioGroup
                        className="rowflex"
                        aria-labelledby="bussinessType"
                        name="bussinessType"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.bussinessType}
                      >
                        <FormControlLabel
                          value="yes"
                          control={
                            <Radio
                              sx={{
                                "&.Mui-checked": {
                                  color: red[600],
                                },
                              }}
                            />
                          }
                          label={<p className="text-sm">Yes </p>}
                        />

                        <FormControlLabel
                          value="no"
                          control={
                            <Radio
                              sx={{ "&.Mui-checked": { color: red[600] } }}
                            />
                          }
                          label={<p className="text-sm">No</p>}
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="flex-1 flex flex-col"></div>
            </div>
          </div>
        </div>
        <div className="sm:flex block flex-col justify-center items-center mt-[1rem] ">
          <div className="flex flex-col gap-1 p-8 shadow-card text-sm md:w-[45rem] sm:w-[40rem] w-[auto] mx-[1rem] rounded-md transition-all duration-500 pt-0">
            <div className="flex gap-4 mt-4" id="form1">
              <div className="flex-1 flex flex-col gap-1">
                <div className="sm:flex grid gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="compAccTitle"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="compAccTitle"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.compAccTitle}
                      />
                      <label
                        htmlFor="compAccTitle"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Company Name/ Acc. Title{" "}
                        <span className="text-[red] text-[15px] ml-[-3px]">
                          *
                        </span>
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.compAccTitle &&
                        formik?.errors?.compAccTitle
                      }
                    />
                  </div>

                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="ownerName"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="ownerName"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.ownerName}
                      />
                      <label
                        htmlFor="ownerName"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Owner Name{" "}
                        <span className="text-[red] text-[15px] ml-[-3px]">
                          *
                        </span>
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.ownerName && formik?.errors?.ownerName
                      }
                    />
                  </div>
                </div>
                <div className="sm:flex grid gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="cnic"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="cnic"
                        onChange={handleCnicChange} // Use the custom handleCnicChange function
                        onBlur={formik.handleBlur}
                        value={formik.values.cnic}
                      />
                      <label
                        htmlFor="cnic" // Use 'htmlFor' instead of 'for' for the label
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        CNIC Number{" "}
                        <span className="text-[red] text-[15px] ml-[-3px]">
                          *
                        </span>
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.cnic && formik?.errors?.cnic}
                    />
                  </div>

                  {/* <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="cnic"
                        class="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="cnic"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.cnic}
                      />
                      <label
                        htmlFor="cnic"
                        class="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        CNIC Number*
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.cnic && formik?.errors?.cnic}
                    />
                  </div> */}

                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        id="ntn"
                        type="text"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-black focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="ntn"
                        onChange={(event) => {
                          const value = event.target.value.replace(
                            /[^\d-]/g,
                            ""
                          );
                          formik.handleChange(event.target.name)(value);
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.ntn}
                        disabled={formik.values.bussinessType === "no"}
                        maxLength={15}
                      />
                      <label
                        htmlFor="ntn"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        NTN Number{" "}
                        <span className="text-[red] text-[15px] ml-[2px]">
                          *
                        </span>
                        {formik?.values?.bussinessType === "yes" ? "" : ""}
                      </label>
                    </div>
                    {/* <ErrorText
                      text={formik?.touched?.ntn && formik?.errors?.ntn}
                    /> */}
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="MuiFormControl-root flex-1">
                    <div className="relative">
                      <Select
                        className="select1"
                        placeholder="Origin (city)*"
                        name="city"
                        id="city"
                        value={formik?.values?.city}
                        options={cities}
                        onChange={(e) => {
                          formik?.setFieldValue("city", e);
                        }}
                        onBlur={(e) => {
                          formik?.setFieldTouched("city", true);
                        }}
                      />
                    </div>
                    <ErrorText
                      text={formik?.touched?.city && formik?.errors?.city}
                    />
                  </div>
                  <div className="MuiFormControl-root flex-1">
                    <div className="relative">
                      <Select
                        className="select1"
                        placeholder="Area"
                        name="area"
                        id="area"
                        value={formik?.values?.area}
                        options={area}
                        onChange={(e) => {
                          formik?.setFieldValue("area", e);
                        }}
                        onBlur={(e) => {
                          formik?.setFieldTouched("area", true);
                        }}
                      />
                    </div>
                    <ErrorText
                      text={formik?.touched?.area && formik?.errors?.area}
                    />
                  </div>

                  {/* <div className="MuiFormControl-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="location"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="location"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.location}
                      />
                      <label
                        htmlFor="location"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Location
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.location && formik?.errors?.location
                      }
                    />
                  </div> */}
                </div>
                <div className="flex gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="pickAddress"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="pickAddress"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.pickAddress}
                      />
                      <label
                        htmlFor="pickAddress"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Pickup Address{" "}
                        <span className="text-[red] text-[15px] ml-[-3px]">
                          *
                        </span>
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.pickAddress &&
                        formik?.errors?.pickAddress
                      }
                    />
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="number"
                        id="compNum"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="compNum"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.compNum}
                      />
                      <label
                        htmlFor="compNum"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Company Ph#{" "}
                        <span className="text-[red] text-[15px] ml-[-3px]">
                          *
                        </span>
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.compNum && formik?.errors?.compNum}
                    />
                  </div>
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="number"
                        id="mobNum"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=""
                        name="mobNum"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.mobNum}
                      />
                      <label
                        htmlFor="mobNum"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Mobile Number{" "}
                        <span className="text-[red] text-[15px] ml-[-3px]">
                          *
                        </span>
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.mobNum && formik?.errors?.mobNum}
                    />
                  </div>
                </div>
                <div className="sm:flex grid gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="number"
                        id="mobNum2"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="mobNum2"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.mobNum2}
                      />
                      <label
                        htmlFor="mobNum2"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Mobile Number 2{" "}
                        <span className="text-[red] text-[15px] ml-[-3px]">
                          *
                        </span>
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.mobNum2 && formik?.errors?.mobNum2}
                    />
                  </div>
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="compEmail"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="compEmail"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.compEmail}
                      />
                      <label
                        htmlFor="compEmail"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Company Email{" "}
                        <span className="text-[red] text-[15px] ml-[-3px]">
                          *
                        </span>
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.compEmail && formik?.errors?.compEmail
                      }
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* {!showBottom && (
              <button
                onClick={() => {
                  formik?.handleSubmit();
                }}
                type="submit"
                className=" text-white bg-[#D40511] border border-[#F21E26] md:w-[45rem] sm:w-[40rem] w-[32rem] sm:ml-0  rounded-md mt-1 mb-6 p-1 h-[2.5rem] text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500"
              >
                Submit
              </button>
            )} */}

            {showBottom && (
              <>
                <div className="flex flex-col gap-4">
                  <p className="mt-2 mb-[-1rem] text-lg">Selling Medium</p>
                  <div className="MuiFormGroup-root MuiFormGroup-row mt-[1rem]">
                    <div className="sm:flex">
                      <div className="flex">
                        <div className="flex items-center">
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={formik?.handleChange}
                                name="facebook"
                                value={formik?.values.facebook}
                                sx={{
                                  "&.Mui-checked": { color: red[600] },
                                }}
                              />
                            }
                            label={<p className="text-sm">Facebook</p>}
                          />
                        </div>
                        <div className="flex items-center">
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={formik?.handleChange}
                                name="whatsapp"
                                value={formik?.values.whatsapp}
                                sx={{
                                  "&.Mui-checked": { color: red[600] },
                                }}
                              />
                            }
                            label={<p className="text-sm">WhatsApp</p>}
                          />
                        </div>
                      </div>

                      <div className="flex">
                        <div className="flex items-center">
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={formik?.handleChange}
                                name="website"
                                value={formik?.values.website}
                                sx={{
                                  "&.Mui-checked": { color: red[600] },
                                }}
                              />
                            }
                            label={<p className="text-sm">Website</p>}
                          />
                        </div>

                        <div className="flex items-center">
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={formik?.handleChange}
                                name="instagram"
                                value={formik?.values.instagram}
                                sx={{
                                  "&.Mui-checked": { color: red[600] },
                                }}
                              />
                            }
                            label={<p className="text-sm">Instagram</p>}
                          />
                        </div>
                      </div>

                      <div className="flex items-center mr-4">
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={formik?.handleChange}
                              name="other"
                              value={formik?.values.other}
                              sx={{
                                "&.Mui-checked": { color: red[600] },
                              }}
                            />
                          }
                          label={<p className="text-sm">Others</p>}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex gap-4"></div>
                <div className="sm:flex grid gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="bussinessName"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="bussinessName"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.bussinessName}
                      />
                      <label
                        htmlFor="bussinessName"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Business Name*
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.bussinessName &&
                        formik?.errors?.bussinessName
                      }
                    />
                  </div>
                </div>

                <div className="sm:flex grid gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="billAddress"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="billAddress"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.billAddress}
                      />
                      <label
                        htmlFor="billAddress"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Billing Address*
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.billAddress &&
                        formik?.errors?.billAddress
                      }
                    />
                  </div>
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <select
                        name="categories"
                        id="categories"
                        value={formik.values.categories}
                        onChange={formik?.handleChange}
                        className=" block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                      >
                        <option value="" disabled>
                          Select a category
                        </option>
                        <option value="Sole Proprietorship">
                          Sole Proprietorship
                        </option>
                        <option value="Partership">Partership</option>
                        <option value="Private Label">Private Label</option>
                        <option value=" Limited Liability Corporation">
                          {" "}
                          Limited Liability Corporation
                        </option>
                      </select>
                      <label
                        htmlFor="categories"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Categories
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.categories &&
                        formik?.errors?.categories
                      }
                    />
                  </div>
                </div>
                <div className="sm:flex grid gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <select
                        name="salesTax"
                        id="salesTax"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        onChange={formik?.handleChange}
                      >
                        <option value="no">NO</option>
                        <option value="yes">YES </option>
                      </select>
                      <label
                        htmlFor="salesTax"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Sales Tax
                      </label>
                    </div>
                  </div>
                  {formik.values.salesTax === "yes" && (
                    <div className="MuiFormControl-root MuiTextField-root flex-1">
                      <div className="relative">
                        <select
                          name="bussinessType2"
                          id="bussinessType2"
                          className=" block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          onChange={formik?.handleChange}
                        >
                          <option value="" disabled>
                            Business Type
                          </option>
                          <option value="brick_mortar">
                            Brick & Mortar Store
                          </option>
                          <option value="retail_chain">Retail Chain</option>
                          <option value="facebook_seller">
                            Facebook Seller
                          </option>
                          <option value="instagram_seller">
                            Instagram Seller
                          </option>
                          <option value="marketplace">Marketplace</option>
                        </select>
                        <label
                          htmlFor="bussinessType2"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Business Type
                        </label>
                      </div>
                    </div>
                  )}
                </div>
                <div>
                  <div className="flex gap-4">
                    <div className="flex-1 flex flex-col mt-2">
                      <fieldset className="MuiFormControl-root">
                        <p className="mt-2  text-lg">Months into Business</p>
                        <div
                          className="MuiFormGroup-root rowflex mt-[1rem]"
                          role="radiogroup"
                          aria-label="bussinessType"
                        >
                          <div className="flex">
                            <div className="flex items-center mr-4">
                              <RadioGroup
                                className="rowflex"
                                aria-labelledby="bussinessType"
                                defaultValue="female"
                                name="monthsInBussiness"
                                onChange={formik?.handleChange}
                              >
                                <FormControlLabel
                                  value="Nill"
                                  checked={
                                    formik?.values?.monthsInBussiness === "Nill"
                                  }
                                  control={
                                    <Radio
                                      sx={{
                                        "&.Mui-checked": {
                                          color: red[600],
                                        },
                                      }}
                                    />
                                  }
                                  label={<p className="text-sm">Nil</p>}
                                />

                                <FormControlLabel
                                  value="Less than 6 months"
                                  checked={
                                    formik?.values?.monthsInBussiness ===
                                    "Less than 6 months"
                                  }
                                  control={
                                    <Radio
                                      sx={{
                                        "&.Mui-checked": { color: red[600] },
                                      }}
                                    />
                                  }
                                  label={
                                    <p className="text-sm">
                                      Less than 6 months
                                    </p>
                                  }
                                />

                                <FormControlLabel
                                  value="Less than a year"
                                  checked={
                                    formik?.values?.monthsInBussiness ===
                                    "Less than a year"
                                  }
                                  control={
                                    <Radio
                                      sx={{
                                        "&.Mui-checked": { color: red[600] },
                                      }}
                                    />
                                  }
                                  label={
                                    <p className="text-sm">Less than a year</p>
                                  }
                                />
                              </RadioGroup>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <div className="flex-1 flex flex-col mt-2">
                      <fieldset className="MuiFormControl-root">
                        <p className="mt-2  text-lg">Average Shipments/Week</p>
                        <div
                          className="MuiFormGroup-root rowflex mt-[1rem]"
                          role="radiogroup"
                          aria-label="bussinessType"
                        >
                          <div className="flex">
                            <div className="flex items-center mr-4">
                              <RadioGroup
                                className="rowflex"
                                aria-labelledby="bussinessType"
                                defaultValue="female"
                                name="avgShip"
                                onChange={formik?.handleChange}
                              >
                                <FormControlLabel
                                  value="Nill"
                                  checked={formik?.values?.avgShip === "Nill"}
                                  control={
                                    <Radio
                                      sx={{
                                        "&.Mui-checked": {
                                          color: red[600],
                                        },
                                      }}
                                    />
                                  }
                                  label={<p className="text-sm">Nil</p>}
                                />

                                <FormControlLabel
                                  value="Below 25"
                                  checked={
                                    formik?.values?.avgShip === "Below 25"
                                  }
                                  control={
                                    <Radio
                                      sx={{
                                        "&.Mui-checked": { color: red[600] },
                                      }}
                                    />
                                  }
                                  label={<p className="text-sm">Below 25</p>}
                                />

                                <FormControlLabel
                                  value="Above 25"
                                  checked={
                                    formik?.values?.avgShip === "Above 25"
                                  }
                                  control={
                                    <Radio
                                      sx={{
                                        "&.Mui-checked": { color: red[600] },
                                      }}
                                    />
                                  }
                                  label={<p className="text-sm">Above 25</p>}
                                />
                              </RadioGroup>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                  <div className="flex flex-col gap-1">
                    <p className="mt-2  text-lg">Contact Person</p>
                    <div className="sm:flex grid gap-4 ">
                      <div className="MuiFormControl-root MuiTextField-root flex-1">
                        <div className="relative">
                          <input
                            type="text"
                            id="name"
                            className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                            placeholder=" "
                            name="ownerName"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.ownerName}
                          />
                          <label
                            htmlFor="name"
                            className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                          >
                            Name*
                          </label>
                        </div>
                        <ErrorText
                          text={
                            formik?.touched?.ownerName &&
                            formik?.errors?.ownerName
                          }
                        />
                      </div>
                      <div className="MuiFormControl-root MuiTextField-root flex-1">
                        <div className="relative">
                          <input
                            // type="number"
                            id="PhoneNo"
                            className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                            placeholder=" "
                            name="PhoneNo"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.PhoneNo}
                            maxLength={11}
                          />
                          <label
                            htmlFor="PhoneNo"
                            className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                          >
                            Phone Number*
                          </label>
                        </div>
                        <ErrorText
                          text={
                            formik?.touched?.PhoneNo && formik?.errors?.PhoneNo
                          }
                        />
                      </div>
                    </div>
                    <div className="sm:flex grid gap-4">
                      <div className="MuiFormControl-root MuiTextField-root flex-1">
                        <div className="relative">
                          <input
                            type="text"
                            id="designation"
                            className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                            placeholder=" "
                            name="designation"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.designation}
                          />
                          <label
                            htmlFor="designation"
                            className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                          >
                            Designation*
                          </label>
                        </div>
                        <ErrorText
                          text={
                            formik?.touched?.designation &&
                            formik?.errors?.designation
                          }
                        />
                      </div>
                      <div className="MuiFormControl-root MuiTextField-root flex-1">
                        <div className="relative">
                          <input
                            type="text"
                            id="custMobNum"
                            className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                            placeholder=" "
                            name="mobNum"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.mobNum}
                            maxLength={11}
                          />
                          <label
                            htmlFor="custMobNum"
                            className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                          >
                            Mobile*
                          </label>
                        </div>
                        <ErrorText
                          text={
                            formik?.touched?.mobNum && formik?.errors?.mobNum
                          }
                        />
                      </div>
                    </div>
                    <div className="sm:flex grid gap-4">
                      <div className="MuiFormControl-root MuiTextField-root flex-1">
                        <div className="relative">
                          <input
                            type="text"
                            id="custEmail"
                            className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                            placeholder=" "
                            name="compEmail"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.compEmail}
                          />
                          <label
                            htmlFor="custEmail"
                            className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                          >
                            Email*
                          </label>
                        </div>
                        <ErrorText
                          text={
                            formik?.touched?.compEmail &&
                            formik?.errors?.compEmail
                          }
                        />
                      </div>
                      <div className="MuiFormControl-root MuiTextField-root flex-1">
                        <div className="relative">
                          <input
                            type="text"
                            id="custCNIC"
                            className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                            placeholder=" "
                            name="cnic"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.cnic}
                          />
                          <label
                            htmlFor="custCNIC"
                            className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                          >
                            CNIC*
                          </label>
                        </div>
                        <ErrorText
                          text={formik?.touched?.cnic && formik?.errors?.cnic}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        {showBottom && (
          <div>
            <div className="sm:flex block flex-col justify-center items-center mt-[1rem] ">
              <div className="flex flex-col gap-3 p-8 shadow-card text-sm  md:w-[45rem] sm:w-[40rem] w-[auto] mx-[1rem] rounded-md transition-all duration-500">
                <h2 className="font-bold text-[1.1rem]">Product Range</h2>
                <div className="flex gap-4">
                  <div className="flex-1 flex flex-col">
                    <p>Please select atleast one product</p>
                    <div className="MuiFormGroup-root MuiFormGroup-row">
                      <div className="flex flex-col sm:flex-row">
                        <div className="flex-1 flex flex-col">
                          <div className="flex items-center ">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name="Clothing"
                                  onChange={handleProdChange}
                                  sx={{
                                    "                         &.Mui-checked": {
                                      color: red[600],
                                    },
                                  }}
                                />
                              }
                              label={<p className="text-sm">Clothing</p>}
                            />
                          </div>
                          <div className="flex items-center">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name="Books"
                                  onChange={handleProdChange}
                                  sx={{
                                    "&.Mui-checked": { color: red[600] },
                                  }}
                                />
                              }
                              label={<p className="text-sm">Books</p>}
                            />
                          </div>

                          <div className="flex items-center">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name="Watches"
                                  onChange={handleProdChange}
                                  sx={{
                                    "&.Mui-checked": { color: red[600] },
                                  }}
                                />
                              }
                              label={<p className="text-sm">Watches</p>}
                            />
                          </div>

                          <div className="flex items-center">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name="Perfumes and Cosmetics"
                                  onChange={handleProdChange}
                                  sx={{
                                    "&.Mui-checked": { color: red[600] },
                                  }}
                                />
                              }
                              label={
                                <p className="text-sm">
                                  Perfumes and Cosmetics
                                </p>
                              }
                            />
                          </div>

                          <div className="flex items-center">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name="Sports"
                                  onChange={handleProdChange}
                                  sx={{
                                    "&.Mui-checked": { color: red[600] },
                                  }}
                                />
                              }
                              label={<p className="text-sm">Sports</p>}
                            />
                          </div>
                        </div>

                        <div className="flex-1 flex flex-col">
                          <div className="flex items-center">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name="Home Decor"
                                  onChange={handleProdChange}
                                  sx={{
                                    "&.Mui-checked": { color: red[600] },
                                  }}
                                />
                              }
                              label={<p className="text-sm">Home Decor</p>}
                            />
                          </div>

                          <div className="flex items-center">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name="Home Appliances"
                                  onChange={handleProdChange}
                                  sx={{
                                    "&.Mui-checked": { color: red[600] },
                                  }}
                                />
                              }
                              label={<p className="text-sm">Home Appliances</p>}
                            />
                          </div>

                          <div className="flex items-center ">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name="Health and Fitness"
                                  onChange={handleProdChange}
                                  sx={{
                                    "&.Mui-checked": { color: red[600] },
                                  }}
                                />
                              }
                              label={
                                <p className="text-sm">Health and Fitness</p>
                              }
                            />
                          </div>

                          <div className="flex items-center ">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name="Mobile and Tablets (PTA Approved)"
                                  onChange={handleProdChange}
                                  sx={{
                                    "&.Mui-checked": { color: red[600] },
                                  }}
                                />
                              }
                              label={
                                <p className="text-sm">
                                  Mobile and Tablets (PTA Approved)
                                </p>
                              }
                            />
                          </div>

                          <div className="flex items-center mb-3">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name="Computer, Peripherals and Accessories"
                                  onChange={handleProdChange}
                                  sx={{
                                    "&.Mui-checked": { color: red[600] },
                                  }}
                                />
                              }
                              label={
                                <p className="text-sm">
                                  Computer, Peripherals and Accessories
                                </p>
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex-1 flex flex-col">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="floating_outlined"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        onChange={(e) =>
                          formik?.setFieldValue("prodRange", {
                            ...formik?.values?.prodRange,
                            other: e?.target?.value,
                          })
                        }
                        name="prodRange"
                        onBlur={formik.handleBlur}
                        value={formik.values.prodRange?.other}
                      />

                      <label
                        htmlFor="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Other (Please Specify)
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.prodRange && formik?.errors?.prodRange
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {showBottom && (
        <div>
          <div className="sm:flex block flex-col justify-center items-center mt-[1rem] ">
            <div className="flex flex-col gap-1 p-8 shadow-card text-sm  md:w-[45rem] sm:w-[40rem] w-[auto] mx-[1rem] rounded-md transition-all duration-500">
              <h2 className="font-bold text-[1.1rem]">
                Rates &amp; Acceptance
              </h2>

              <div className="flex gap-4">
                <div className="flex-1 flex flex-col">
                  <div className="sm:flex grid gap-[0.1rem]">
                    <div className="bg-[#f21e26] text-white rounded-l-md h-[2.5rem] flex-1 flex justify-center items-center">
                      24-48 Hours Delivery{" "}
                    </div>
                    {/* <div className="bg-[#f21e26] text-white rounded-r-md h-[2.5rem] flex-1 flex justify-center items-center">
                  Destination
                </div> */}
                  </div>
                  <table className="mt-6">
                    <thead>
                      <tr className="text-left bg-gray-100">
                        <th className="border p-2">Zone Key</th>
                        <th className="border p-2">Zones</th>
                        <th className="border p-2">0.5 Kg</th>
                        <th className="border p-2">1 Kg & Each Add Kg</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="border p-2">Same City</td>
                        <td className="border p-2">Same City</td>
                        <td className="border p-2">110</td>
                        <td className="border p-2">120</td>
                      </tr>
                      <tr>
                        <td className="border p-2">
                          Within Sindh/Within Punjab, ISB & AJK/Within KPK
                        </td>
                        <td className="border p-2">Same Zone</td>
                        <td className="border p-2">160</td>
                        <td className="border p-2">180</td>
                      </tr>
                      <tr>
                        <td className="border p-2">
                          Within Province Far-flung Remote Locations
                        </td>
                        <td className="border p-2">Same Zone Ext</td>
                        <td className="border p-2">230</td>
                        <td className="border p-2">240</td>
                      </tr>
                      <tr>
                        <td className="border p-2">
                          Province to Province (Punjab, South Punjab,
                          Baluchistan, ISB, AJK & KPK)
                        </td>
                        <td className="border p-2">Diff Zone</td>
                        <td className="border p-2">190</td>
                        <td className="border p-2">200</td>
                      </tr>
                      <tr>
                        <td className="border p-2">
                          Sindh to Punjab, KPK, ISB, AJK, Baluchistan & Vice
                          Versa
                        </td>
                        <td className="border p-2">Diff Zone 2</td>
                        <td className="border p-2">240</td>
                        <td className="border p-2">250</td>
                      </tr>
                      <tr>
                        <td className="border p-2">
                          Sindh to Punjab, KPK, ISB, AJK, Baluchistan Far-flung,
                          Remote Locations & Vice Versa
                        </td>
                        <td className="border p-2">Diff Zone Ext</td>
                        <td className="border p-2">250</td>
                        <td className="border p-2">270</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="flex gap-4 mt-4">
                <div className="flex-1 flex flex-col">
                  <div className="sm:flex grid gap-[0.1rem]">
                    <div className="bg-[#f21e26] text-white rounded-l-md h-[2.5rem] flex-1 flex justify-center items-center text-[0.8rem]">
                      ECONOMY EXPRESS (48-72 Hrs)
                    </div>
                    <div className="bg-[#f21e26] text-white rounded-r-md h-[2.5rem] flex-1 flex justify-center items-center">
                      Upto 3 kg
                    </div>
                    <div className="bg-[#f21e26] text-white rounded-r-md h-[2.5rem] flex-1 flex justify-center items-center">
                      Each Add kg
                    </div>
                  </div>
                  <table className="mt-6">
                    <thead>
                      <tr className="text-left bg-gray-100">
                        <th className="border p-2">Nationwide</th>
                        <th className="border p-2">300</th>
                        <th className="border p-2">100</th>
                      </tr>
                    </thead>
                  </table>
                </div>
              </div>
              <div className="flex gap-4 mt-4">
                <div className="flex-1 flex flex-col"></div>
              </div>
              <div className="flex gap-4">
                <div className="flex-1 flex flex-col">
                  <p className="mt-2 mb-[-1rem] text-lg">
                    Bank Account Details for IBFT
                  </p>
                </div>
              </div>
              <div className="sm:flex grid gap-4 mt-4">
                <div className="MuiFormControl-root MuiTextField-root flex-1">
                  <div className="relative">
                    <input
                      type="text"
                      id="iban"
                      className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                      placeholder=" "
                      name="iban"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.iban}
                      maxLength={24}
                      minLength={24}
                    />

                    <label
                      htmlFor="iban"
                      className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                    >
                      IBAN #
                    </label>
                  </div>
                  <ErrorText
                    text={formik?.touched?.iban && formik?.errors?.iban}
                  />
                </div>
                <div className="MuiFormControl-root MuiTextField-root flex-1">
                  <div className="relative">
                    <input
                      type="text"
                      id="bankName"
                      className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                      placeholder=" "
                      name="bankName"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.bankName}
                    />

                    <label
                      htmlFor="bankName"
                      className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                    >
                      Bank Name
                    </label>
                  </div>
                  <ErrorText
                    text={formik?.touched?.bankName && formik?.errors?.bankName}
                  />
                </div>
              </div>
              <div className="sm:flex grid gap-4 ">
                <div className="MuiFormControl-root MuiTextField-root flex-1">
                  <div className="relative">
                    <input
                      type="text"
                      id="branch"
                      className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                      placeholder=" "
                      name="branch"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.branch}
                    />

                    <label
                      htmlFor="branch"
                      className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                    >
                      Branch
                    </label>
                  </div>
                  <ErrorText
                    text={formik?.touched?.branch && formik?.errors?.branch}
                  />
                </div>
                <div className="MuiFormControl-root MuiTextField-root flex-1">
                  <div className="relative">
                    <input
                      type="text"
                      id="bankAcTitle"
                      className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                      placeholder=" "
                      name="bankAcTitle"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.bankAcTitle}
                    />

                    <label
                      htmlFor="bankAcTitle"
                      className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                    >
                      Bank A/C Title
                    </label>
                  </div>
                  <ErrorText
                    text={
                      formik?.touched?.bankAcTitle &&
                      formik?.errors?.bankAcTitle
                    }
                  />
                </div>
              </div>
            </div>
            <div className="sm:flex block flex-col justify-center items-center mt-[1rem] ">
              <div className="flex flex-col gap-3 p-8 shadow-card text-sm  md:w-[45rem] sm:w-[40rem] w-[auto] mx-[1rem] rounded-md transition-all duration-500">
                <h2 className="font-bold text-[1.1rem]">
                  Terms &amp; Conditions
                </h2>
                <div className="flex gap-4">
                  <div className="flex-1 flex flex-col">
                    <div className="MuiFormGroup-root">
                      <div className="flex items-center mr-4">
                        <FormControlLabel
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          checked={formik.values.termCond}
                          name="termCond"
                          control={
                            <Checkbox
                              sx={{ "&.Mui-checked": { color: red[600] } }}
                            />
                          }
                          label={
                            <p className="text-sm">
                              I have read and hereby accept the{" "}
                              <a
                                rel="noopener noreferrer"
                                target="_blank"
                                href="/TermsAndCond"
                                className="text-[#337ab7]"
                              >
                                Terms and Conditions
                              </a>
                            </p>
                          }
                        />
                      </div>
                      <ErrorText
                        text={
                          formik?.touched?.termCond && formik?.errors?.termCond
                        }
                      />

                      <div className="flex items-center mt-0">
                        <FormControlLabel
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          checked={formik.values.undertak}
                          name="undertak"
                          control={
                            <Checkbox
                              sx={{ "&.Mui-checked": { color: red[600] } }}
                            />
                          }
                          label={
                            <p className="text-sm">
                              I have read and hereby accept the{" "}
                              <a
                                rel="noopener noreferrer"
                                target="_blank"
                                href="/RegUndertaking"
                                className="text-[#337ab7]"
                              >
                                Undertaking
                              </a>
                            </p>
                          }
                        />
                      </div>
                      <ErrorText
                        text={
                          formik?.touched?.undertak && formik?.errors?.undertak
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="flex-1 flex flex-col"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="sm:flex block flex-col justify-center items-center mt-[1rem] ">
        <div className="flex flex-col mx-[1rem]">
          <button
            onClick={() => {
              if (clickCount >= 2) return;
              const tempCount = clickCount + 1;
              setClickCount(tempCount);
              console.log(formik?.errors);
              console.log(formik?.values);
              if (!showBottom) handleInitial();
              else formik?.handleSubmit();
            }}
            disabled={isButtonDisabled}
            // disabled={isSubmitted}
            type="submit"
            className=" text-white bg-[#D40511] border border-[#F21E26] md:w-[45rem] sm:w-[40rem] w-[32rem] sm:ml-0  rounded-md mt-1 mb-6 p-1 h-[2.5rem] text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500"
          >
            {showBottom ? "Submit" : "Save & Continue"}
          </button>
        </div>
      </div>
      <BootstrapDialog
        onClose={() => setOpen(false)}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <div className="w-[30rem] pt-2 pb-1 pl-2">
          <h1>Enter Query</h1>
          <div className="flex w-full pt-2 pb-2">
            <div className="relative w-[30rem] ">
              <input
                type="text"
                rows="4rem"
                id="floating_outlined"
                className="row-5 block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                placeholder=" "
              />
              <label
                htmlFor="floating_outlined"
                rows="4"
                className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
              >
                Customer Name/Account Title
              </label>
            </div>
          </div>

          <div className="flex p-[1rem] justify-end ">
            <div className="mr-[1rem]">
              <Button variant="outlined">Text</Button>
            </div>

            <div>
              <Button variant="contained" color="error">
                Submit1
              </Button>
            </div>
          </div>
        </div>
        {/* </Modal> */}
      </BootstrapDialog>

      <div
        ref={modalRef}
        // style={backdropStyle}
        className={`${styles.modal__wrap}`}
        onClick={() => setShow(false)}
      >
        <div
          className={`flex flex-col justify-center items-center ${styles.modal}`}
        >
          <div className="bg-white w-full h-[106%] relative z-[1000] rounded-3xl">
            <div className="flex justify-center items-center">
              <img
                src="/popup-circle.png"
                alt=""
                className="mx-auto w-[12.5rem]"
              />
              <img
                src="/popup-icon.png"
                alt=""
                className="absolute top-[-3.5rem] mx-auto w-[7rem]"
              />
            </div>
            <div className="absolute right-[1rem] top-[1rem] ">
              <CloseIcon fontSize="large" style={{ color: "#f21e26" }} />
            </div>
            <div className="flex flex-col text-center justify-center item-center mt-[6rem]">
              <h2 className="font-bold text-xl">Thank you for submitting.</h2>
              <p>We’ll contact you soon.</p>
            </div>
          </div>
          <div className="mx-auto bg-[#ed1d25] w-[80%] h-[2rem] rounded-full mt-[-1.2rem]"></div>
        </div>
      </div>
    </div>
  );
};

export default TcsEcom;
